// Story 12.4 — Polls /api/v1/bots/:id/whatsapp/status. Adaptive interval:
// while not linked we poll every 5s (during onboarding the user expects
// fast feedback), once linked we slow to 60s (state rarely changes).

import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

export type EvolutionLinkState = 'linked' | 'reconnecting' | 'qr-pending' | 'disconnected';

export interface EvolutionStatusResponse {
  connected: boolean;
  loggedIn: boolean;
  /** Story 17-2 — falta en APIs anteriores; ver `linkStateOf`. */
  state?: EvolutionLinkState;
  jid?: string;
  name?: string;
  provider: 'evolution-go';
}

/**
 * Story 17-2 — vinculado es `loggedIn`: Evolution GO v0.7 pone `connected` en
 * true mientras muestra el QR. Sin `state` (API anterior), sale de los flags.
 */
export function linkStateOf(status: EvolutionStatusResponse | undefined): EvolutionLinkState {
  if (!status) return 'disconnected';
  if (status.state) return status.state;
  if (status.loggedIn) return status.connected ? 'linked' : 'reconnecting';
  return status.connected ? 'qr-pending' : 'disconnected';
}

export function useEvolutionStatus(botId: number, opts: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ['bots', botId, 'evolution-status'] as const,
    queryFn: () => api.get<EvolutionStatusResponse>(`/api/v1/bots/${botId}/whatsapp/status`),
    refetchInterval: (query) => {
      const data = query.state.data as EvolutionStatusResponse | undefined;
      return linkStateOf(data) === 'linked' ? 60_000 : 5_000;
    },
    enabled: (opts.enabled ?? true) && Number.isFinite(botId),
  });
}
